<template>
  <div class="w-full p-6 h-full">
    <div class="text-secondary-invert text-xs font-bold mb-2 uppercase">
      {{ $t('frontend_layout_type') }}
      <div class="flex flex-row justify-center pt-4 pb-4">
        <gd-button
          v-for="(type, position) in layoutTypes"
          :key="type.value"
          size="md"
          :variant="layoutType === type.value ? 'primary' : 'dark'"
          :group-position="getButtonGroupPosition(position, layoutTypes)"
          @click="updateLayoutType(type.value)"
        >
          {{ type.text }}
        </gd-button>
      </div>
    </div>
    <div class="text-secondary-invert text-xs font-bold mb-2 uppercase">
      {{ $t('frontend_plugin_divider_align_label') }}
      <div class="flex flex-row justify-center pt-4 pb-4">
        <gd-button
          v-for="(type, position) in alignmentOptions"
          :key="type.value"
          size="md"
          :variant="alignment === type.value ? 'primary' : 'dark'"
          :group-position="getButtonGroupPosition(position, alignmentOptions)"
          @click="updateAlignment(type.value)"
        >
          {{ type.text }}
        </gd-button>
      </div>
    </div>
    <div class="text-secondary-invert text-xs font-bold mb-4 uppercase">
      <div class="flex justify-between">
        <span class="font-semibold mr-2">
          {{ $t('frontend_groovemember_course_listing_hide') }} {{ $t('frontend_groovemail_customfields_index_field_label') }}
        </span>
        <gd-toggle
          bgClass="bg-secondary"
          v-model="hideLabels"
        />
      </div>
    </div>
    <div class="text-secondary-invert text-xs font-bold mb-4 uppercase">
      <div class="justify-between">
        <span class="font-semibold mr-2">{{ $t('frontend_preview_witdh') }}</span>
        <screen-size class="mt-5"></screen-size>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import ScreenSize from '@/components/ScreenSize.vue';

export default {
  name: 'SettingsMenu',
  components: {
    ScreenSize,
  },
  props: {
      updateMenuOpen: {},
      activeTemplate: {},
      updateActiveTemplate: {},
  },
  data() {
    return {
      layoutTypes: [
        { text: 'Vertical' , value: 'vertical' },
        { text: 'Horizontal' , value: 'horizontal' },
        { text: 'Custom' , value: 'custom' },
      ],
      alignmentOptions: [
        { text: this.$t('frontend_left'), value: 'left' },
        { text: this.$t('frontend_groovemail_email_builder_image_align_option_center'), value: 'center' },
        { text: this.$t('frontend_right'), value: 'right' },
      ],
    };
  },
  computed: {
    ...mapState({
      layoutType: state => state.forms.layoutType,
      alignment: state => state.forms.alignment,
    }),
    hideLabels: {
      get: function() { 
        return this.$store.state.forms.hideLabels
      },
      set: function(newValue) {
        this.$store.commit('forms/SET_HIDE_LABELS', newValue);
      }
    },
  },

  methods: {
    getButtonGroupPosition(position, variable) {
      if (position === 0) return 'left';
      if (position === variable.length - 1) return 'right';
      return 'middle';
    },
    updateLayoutType(value) {
      this.$store.commit('forms/SET_LAYOUT_TYPE', value);
    },
    updateAlignment(value) {
      this.$store.commit('forms/SET_ALIGNMENT', value);
    },
  },
};
</script>